import React, {useState} from 'react';
import './Admin.css'
import {
    validatePersonalInfo,
    validateMedicalInfo,
    validateIdentificationInfo,
  } from '../../utils/validation';
  import { initialAbonneFormData } from '../../utils/formData'

function AbonneForm() {

    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});

    // initialisation des  champs du formulaire
    const [formData, setFormData] = useState(initialAbonneFormData);


  // Fonction pour gérer les changements dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Fonction pour valider les champs
  const validateFields = () => {
    let newErrors = {};

    if (currentStep === 1) {
        newErrors = validatePersonalInfo(formData);
    }

    if (currentStep === 2) {
        newErrors = validateMedicalInfo(formData);
    }

    if (currentStep === 3) {
        newErrors = validateIdentificationInfo(formData);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //fonction pour les buttons suivants avec le controle de validation
    const handleNext = () => {
        if (validateFields()) {
            setCurrentStep(currentStep + 1);
          }
    };

    // fonction pour le button de retour
    const handleBack = () => {
        setCurrentStep(currentStep - 1);
    };

    //fonction de soumission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFields()) {
          console.log('Formulaire soumis avec succès:', formData);
        }
      };

  return (
      <form onSubmit={handleSubmit} className='inscription-form'>
        {currentStep === 1 && (
          <div className="form-step">
            <h2 className='inscription-title'>Ajouter un abonnée</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Prénom</label>
                    <input type="text" placeholder="Entrez le prénom" name="prenom" value={formData.prenom} onChange={handleChange} />
                    {errors.prenom && <span className="error">{errors.prenom}</span>}
                </div>
                <div className="form-group">
                    <label>Nom</label>
                    <input type="text" name="nom" placeholder="Entrez le nom" value={formData.nom} onChange={handleChange}/>
                    {errors.nom && <span className="error">{errors.nom}</span>}
                </div>
                <div className="form-group">
                    <label>Résidence</label>
                    <input type="text" name="residence" placeholder="Entrez la Résidence" value={formData.residence} onChange={handleChange}/>
                    {errors.residence && <span className="error">{errors.residence}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name='email' placeholder="Entrez l'email" required value={formData.email} onChange={handleChange} />
                    {errors.email && <span className="error">{errors.email}</span>}
                </div>
                <div className="form-group">
                    <label>Numéro de téléphone</label>
                    <input type="tel" name="telephone" placeholder="+223 ..." value={formData.telephone} onChange={handleChange} />
                    {errors.telephone && <span className="error">{errors.telephone}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                <label>Genre</label>
                <select name="genre" value={formData.genre} onChange={handleChange}>
                    <option value="">Sélectionnez le Genre</option>
                    <option value="male">Masculin</option>
                    <option value="female">Féminin</option>
                </select>
                {errors.genre && <span className="error">{errors.genre}</span>}
                </div>
                <div className="form-group">
                    <label>Date de naissance</label>
                    <input type="date" name="dateNaissance" value={formData.dateNaissance} onChange={handleChange} />
                    {errors.dateNaissance && <span className="error">{errors.dateNaissance}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="type-carte">Type de carte</label>
                    <select id="type-carte" name="typeCarte" value={formData.typeCarte} onChange={handleChange}>
                        <option value="">Type de carte</option>
                        <option value="bronze">Mineur</option>
                        <option value="argent">Majeur</option>
                    </select>
                    {errors.typeCarte && <span className="error">{errors.typeCarte}</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="type-carte">Structure partenaire</label>
                    <select id="structure" name="structure" value={formData.structure} onChange={handleChange}>
                        <option value="">Structure</option>
                        <option value="OM">Orange Mali</option>
                        <option value="MS">Ministère de la santé</option>
                        <option value="STM">Société des Télécommunications du Mali</option>
                        <option value="BDM">Banque de Développement du Mali</option>
                        <option value="SEM">Société des Eaux du Mali</option>
                        <option value="ME">Ministère de l'Éducation</option>
                    </select>
                    {errors.structure && <span className="error">{errors.structure}</span>}
                </div>
            </div>

            <div className="form-group">
                    <label>Profession</label>
                    <input type="text" name="job" placeholder="la profession...." value={formData.job} onChange={handleChange}/>
                    {errors.job && <span className="error">{errors.job}</span>}
                </div>
            
            <div className="form-group">
                <label htmlFor="info-supplementaire">Info supplémentaire</label>
                <textarea id="info-supplementaire" placeholder="Les autres Informations"></textarea>
            </div>
          </div>
        )}

        {/* {currentStep === 2 && (
          <div className="form-step">
            <div className="left-section">
                <h2 className='inscription-title'>Informations médicales</h2>
                <div className="form-group">
                    <label>Antécédents médicaux</label>
                    <input type="text" name="antecedentsMedicaux" placeholder="maladies chroniques, allergies, etc."  value={formData.antecedentsMedicaux} onChange={handleChange}/>
                    {errors.antecedentsMedicaux && <span className="error">{errors.antecedentsMedicaux}</span>}
                </div>
                <div className="form-group">
                    <label>Médicaments actuels</label>
                    <input type="text" name="medicamentsActuels" placeholder="la liste des médicaments" value={formData.medicamentsActuels} onChange={handleChange}/>
                    {errors.medicamentsActuels && <span className="error">{errors.medicamentsActuels}</span>}
                </div>
                <div className="form-group">
                    <label>Nom du médecin traitant</label>
                    <input type="text" name="medecinTraitant" placeholder="Nom complet du médecin" value={formData.medecinTraitant} onChange={handleChange} />
                    {errors.medecinTraitant && <span className="error">{errors.medecinTraitant}</span>}
                </div>
                <div className="form-group">
                    <label>Numéro de sécurité sociale</label>
                    <input type="text" name="numeroSecuriteSociale" placeholder="identifiant de santé" value={formData.numeroSecuriteSociale} onChange={handleChange} />
                    {errors.numeroSecuriteSociale && <span className="error">{errors.numeroSecuriteSociale}</span>}
                </div>
            </div>

            <div className="right-section">
                <h2 className='inscription-title'>Informations sur la pharmacie</h2>
                <div className="form-group">
                    <label>Nom de la pharmacie</label>
                    <input type="text" name="nomPharmacie" placeholder="Nom de la pharmacie" value={formData.nomPharmacie}
                    onChange={handleChange} />
                    {errors.nomPharmacie && <span className="error">{errors.nomPharmacie}</span>}
                </div>
                <div className="form-group">
                    <label>Adresse de la pharmacie</label>
                    <input type="text" name="adressePharmacie" placeholder="adresse de la pharmacie" value={formData.adressePharmacie} onChange={handleChange} />
                    {errors.adressePharmacie && <span className="error">{errors.adressePharmacie}</span>}
                </div>
                <div className="form-group">
                    <label>Historique des ordonnance</label>
                    <textarea type="text" placeholder="Nom complet du médecin"></textarea>
                </div>
                <div className="form-group">
                    <label>Date de la dernière visite à la pharmacie</label>
                    <input type="date" placeholder="identifiant de santé" />
                </div>
            </div>
            
          </div>
          
        )} */}

        {currentStep === 2 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations d'identification</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom d'utilisateur</label>
                    <input type="text" name="username" placeholder="Entrez le nom d'utilisateur" value={formData.username} onChange={handleChange} />
                    {errors.username && <span className="error">{errors.username}</span>}
                </div>
                <div className="form-group">
                    <label>Mot de passe</label>
                    <input type="password"  name="password" placeholder="Entrez le mot de passe" value={formData.password} onChange={handleChange} />
                    {errors.password && <span className="error">{errors.password}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Question de sécurité</label>
                    <input type="text" name="questionSecurite" placeholder="Entrez une question de sécurité" value={formData.questionSecurite} onChange={handleChange} />
                    {errors.questionSecurite && <span className="error">{errors.questionSecurite}</span>}
                </div>
                <div className="form-group">
                    <label>Langue préférée</label>
                    <select name="languePreferee" value={formData.languePreferee} onChange={handleChange}>
                        <option value="">Choix de langue</option>
                        <option value="fr">Français</option>
                        <option value="en">Anglais</option>
                    </select>
                    {errors.languePreferee && <span className="error">{errors.languePreferee}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Préférences pour les notifications par SMS ou par email</label>
                    <select name="notificationPreference" value={formData.notificationPreference} onChange={handleChange} >
                        <option value="">Sélectionnez</option>
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                    </select>
                    {errors.notificationPreference && <span className="error">{errors.notificationPreference}</span>}
                </div>
                <div className="form-group">
                <label>consentement eclairé (pour les données à carractères personnelles et l'utilisation de l'application)</label>
                <select>
                    <option value="">Sélectionnez</option>
                    <option value="email">Oui</option>
                    <option value="sms">Non</option>
                </select>
                </div>
            </div>
          </div>
        )}

        <div className="form-navigation">
        {currentStep > 1 && (
            <button type="button" onClick={handleBack} className="back-button">
            Retour
            </button>
        )}
        {currentStep < 2 ? (
            <button type="button" onClick={handleNext} className="next-button">
                Suivant
            </button>
        ) : (
            <button type="submit" className="submit-button">
                Enregistrer
            </button>
        )}
        </div>
      </form>
  )
}

export default AbonneForm